import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import disablePluginEditing from './disablepluginediting';

export default class DisablePlugin extends Plugin {
  static get requires() {
    return [ disablePluginEditing ];
  }

  static get pluginName() {
    return 'disablePlugin';
  }
}